<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-9 col-sm float-left">
            <h1 class="page-title">IPD List</h1>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-3 mt-3">
                    <div class="col-sm-3 mt-1"><input class="form-control" [(ngModel)]="search" type="text"
                            placeholder="Search" /></div>

                    <div class="col-sm-2 mt-1">
                        <mat-select placeholder="Treatment" [(ngModel)]="treatment"
                            (click)="setSearchValue('treatment')" multiple>
                            <input class="mySearchInput" #treatmentSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="treatmentSearch">
                            <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatments">
                                {{ltreatment.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-2 mt-1">
                        <mat-select placeholder="Select City" [(ngModel)]="city" (click)="setSearchValue('city')"
                            multiple>
                            <input class="mySearchInput" #citySearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'city')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="citySearch">
                            <mat-option>Select City</mat-option>
                            <mat-option [value]="city.city_id" *ngFor="let city of cities">{{city.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-2 mt-1">
                        <mat-select placeholder="Payment Mode" [(ngModel)]="payment_mode" multiple>
                            <mat-option value="1">Cash</mat-option>
                            <mat-option value="2">Cashless</mat-option>
                            <mat-option value="3">Reimbursement</mat-option>
                            <mat-option value="4">EMI</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-2 mt-1">
                        <mat-select placeholder="Gender" [(ngModel)]="gender">
                            <mat-option>All</mat-option>
                            <mat-option value="Male">Male</mat-option>
                            <mat-option value="Female">Female</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-2 mt-5">
                        <mat-select placeholder="Doctor" [(ngModel)]="doctor" (click)="setSearchValue('doctor')"
                            multiple>
                            <input class="mySearchInput" #doctorSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'doctor')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="doctorSearch">
                            <mat-option [value]="odoctor.id" *ngFor="let odoctor of doctors">{{odoctor.name}}
                            </mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-5">
                        <mat-form-field appearance="fill">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date"
                                    (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
                    </div>

                    <div class="col-sm-3 mt-5">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadIpds(0,perpage)"> <i
                                class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                                class="fa fa-sync"></i> Reset Filters</button>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadIpds(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button></div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Status</th>
                            <th class="tablefixcoloumn">Appointment Id</th>
                            <th class="tablefixcoloumn">Glamyo Patient Id</th>
                            <th class="tablefixcoloumn">Patient Name</th>
                            <th *ngIf="userId!='16' && role!='10' && role!='18'  && role!='6'">Patient Mobile</th>
                            <th>Patient Age</th>
                            <th>Patient Gender</th>
                            <th>Lead City</th>
                            <th>Treatment</th>
                            <!-- <th>Doctor</th>
                            <th>Hospital</th> -->
                            <th>Room</th>
                            <th>Payment Mode</th>
                            <th>Surgery Date</th>
                            <th>Arrival DateTime</th>
                            <th>Treatment Time</th>
                            <!-- <th>Billed Amount</th>
                            <th>TPA</th>
                            <th>Insurance Company</th>
                            <th>Policy Number</th>
                            <th>Corporate Name</th>
                            <th>Copay</th> -->
                            <!-- <th>Remarks</th>
                            <th>Aadhar</th>
                            <th>Insurance</th>
                            <th>Discharge Summary</th>
                            <th>Bill Copy</th>
                            <th>Pre-Auth</th>
                            <th>Pre-Approval</th>
                            <th>Final Approval</th>
                            <th>Settlement Letter</th>
                            <th>Other Document</th> -->
                        </tr>
                    </thead>
                    <tbody>

                        <tr *ngFor="let ipd of ipds;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>
                                <span class='p-2 badge' [ngClass]="{'badge-info':ipd.status==0}"
                                    *ngIf="ipd.status==0"><i class="fa fa-dot-circle"></i> Active</span>
                                <span class='p-2 badge' [ngClass]="{'badge-success':ipd.status==1}"
                                    *ngIf="ipd.status==1"><i class="fa fa-check"></i> Completed</span>
                                <span class='p-2 badge' [ngClass]="{'badge-danger':ipd.status==3}"
                                    *ngIf="ipd.status==3"><i class="fa fa-times"></i> Cancelled</span>
                                <span class='p-2 badge' [ngClass]="{'badge-secondary':ipd.status==4}"
                                    *ngIf="ipd.status==4"><i class="fa fa-atom"></i> Postponed</span>
                            </td>

                            <td class="tablefixcoloumn">{{ipd.patient_id}}</td>
                            <td class="tablefixcoloumn">{{ipd.glamyo_patient_id}}</td>

                            <td class="tablefixcoloumn">{{ipd.patient}}</td>
                            <td *ngIf="userId!='16' && role!='10' && role!='18'  && role!='6'">{{ipd.phone}}</td>
                            <td>
                                <span *ngIf="ipd.patient_age!=0">{{ipd.patient_age}}</span>
                                <span *ngIf="ipd.patient_age==0">-</span>
                            </td>
                            <td>
                                <span *ngIf="ipd.gender!='null'">{{ipd.gender}}</span>
                                <span *ngIf="ipd.gender=='null'">-</span>
                            </td>
                            <td>{{ipd.lead_city_name}}</td>
                            <td>{{ipd.treatment_name}}</td>
                            <!-- <td>{{ipd.doctor_name}}</td>
                            <td>{{ipd.hospital_name}}</td> -->
                            <td>
                                {{getRoomCategory(ipd.room)}}
                            </td>
                            <td>{{getPaymentType(ipd.payment_mode)}}</td>

                            <td>{{ipd.surgery_date*1000|date:'d MMM, yyyy'}}</td>
                            <td>{{ipd.arrival_time*1000|date:'d MMM, yyyy hh:mm aa'}}</td>
                            <td>{{ipd.treatment_time*1000|date:'hh:mm aa'}}</td>
                            <!-- <td>{{ipd.billed_amt}}</td>

                            <td>{{ipd.tpa}}</td>
                            <td>{{ipd.insurance_company}}</td>
                            <td>{{ipd.policy_number}}</td>
                            <td>{{ipd.corporate}}</td>
                            <td>{{ipd.copay}}</td>
                            <td>{{ipd.insurance_description}}</td> -->
                            <!-- for insurance role type -->
                            <!-- <td>
                                <div *ngIf="ipd.aadhar_copy.length > 0; else noAadhar">
                                    <span *ngFor="let aDlink of ipd.aadhar_copy"><a href="{{sc3Url+aDlink.aadhar}}"
                                            target="_blank">View</a><br></span>
                                </div>
                                <ng-template #noAadhar>
                                    Not uploaded
                                </ng-template>
                            </td>
                            <td>
                                <div *ngIf="ipd.payment_mode!='1' && ipd.payment_mode!='4'; else notUploaded_Insurance">
                                    <div *ngIf="ipd.insurance_copy.length > 0; else noInsurance">
                                        <span *ngFor="let insurance of ipd.insurance_copy"><a
                                                href="{{sc3Url+insurance.insurance}}"
                                                target="_blank">View</a><br></span>
                                    </div>
                                    <ng-template #noInsurance>
                                        Not uploaded
                                    </ng-template>
                                </div>
                                <ng-template #notUploaded_Insurance>
                            <td>-</td>
                            </ng-template>
                            </td>

                            <td>
                                <div *ngIf="ipd.discharge_summary.length > 0; else noDischarge">
                                    <span *ngFor="let dischargelink of ipd.discharge_summary"><a
                                            href="{{sc3Url+dischargelink.discharge}}"
                                            target="_blank">View</a><br></span>
                                </div>
                                <ng-template #noDischarge>
                                    Not uploaded
                                </ng-template>
                            </td>
                            <td>
                                <div *ngIf="ipd.bill_copy.length > 0; else noBills">
                                    <span *ngFor="let bill of ipd.bill_copy"><a href="{{sc3Url+bill.bills}}"
                                            target="_blank">View</a><br></span>
                                </div>
                                <ng-template #noBills>
                                    Not uploaded
                                </ng-template>
                            </td>


                            <td>
                                <div *ngIf="ipd.payment_mode=='2'; else notUploadedPre_Auth">
                                    <div *ngIf="ipd.pre_auth_copy.length > 0; else noPre_Auth">
                                        <span *ngFor="let pre_auth of ipd.pre_auth_copy"><a
                                                href="{{sc3Url+pre_auth.pre_auth}}" target="_blank">View</a><br></span>
                                    </div>
                                    <ng-template #noPre_Auth>
                                        Not uploaded
                                    </ng-template>
                                </div>
                                <ng-template #notUploadedPre_Auth>
                            <td>-</td>
                            </ng-template>
                            </td>


                            <td>
                                <div *ngIf="ipd.payment_mode=='2'; else notUploadedPre_Approval">
                                    <div *ngIf="ipd.pre_approval_copy.length > 0; else noPre_Approval">
                                        <span *ngFor="let pre_approval of ipd.pre_approval_copy"><a
                                                href="{{sc3Url+pre_approval.pre_approval}}"
                                                target="_blank">View</a><br></span>
                                    </div>
                                    <ng-template #noPre_Approval>
                                        Not uploaded
                                    </ng-template>
                                </div>
                                <ng-template #notUploadedPre_Approval>
                            <td>-</td>
                            </ng-template>
                            </td>


                            <td>
                                <div *ngIf="ipd.payment_mode=='2'; else notUploadedFinal_Approval">
                                    <div *ngIf="ipd.final_approval_copy.length > 0; else noFinal_Approval">
                                        <span *ngFor="let final_approval of ipd.final_approval_copy"><a
                                                href="{{sc3Url+final_approval.final_approval}}"
                                                target="_blank">View</a><br></span>
                                    </div>
                                    <ng-template #noFinal_Approval>
                                        Not uploaded
                                    </ng-template>
                                </div>
                                <ng-template #notUploadedFinal_Approval>
                            <td>-</td>
                            </ng-template>
                            </td>


                            <td>
                                <div *ngIf="ipd.payment_mode!='1' && ipd.payment_mode!='4'; else notUploadedSettelment">
                                    <div *ngIf="ipd.SettlementDoc_copy.length > 0; else noSettlementDoc">
                                        <span *ngFor="let settledoc of ipd.SettlementDoc_copy"><a
                                                href="{{sc3Url+settledoc.SettlementDocs}}"
                                                target="_blank">View</a><br></span>
                                    </div>
                                    <ng-template #noSettlementDoc>
                                        Not uploaded
                                    </ng-template>
                                </div>
                                <ng-template #notUploadedSettelment>
                            <td>-</td>
                            </ng-template>
                            </td>


                            <td>
                                <div *ngIf="ipd.otherDocs.length > 0; else noOtherDocs">
                                    <span *ngFor="let otherDoc of ipd.otherDocs"><a href="{{sc3Url+otherDoc.otherDocs}}"
                                            target="_blank">View</a><br></span>
                                </div>
                                <ng-template #noOtherDocs>
                                    Not uploaded
                                </ng-template>
                            </td> -->

                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !ipds.length">
                            <td colspan="20"><i class="far fa-frown"></i> Ipds not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>

    </div>
</div>